export enum StoreType {
  '2S' = 2,
  '3S' = 3
}
